/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentInfo, DocumentState } from '../document-info.model';

@Component({
  selector: 'app-file-icon',
  templateUrl: './file-icon.component.html',
  styleUrls: ['./file-icon.scss'],
})
export class FileIconComponent implements OnInit {
  @Input() documentInfo?: DocumentInfo | any;
  @Input() removable = true;
  @Input() showItemBorder = true;
  @Output() onFileRemove = new EventEmitter<void>();
  documentState: typeof DocumentState = DocumentState;

  constructor() {}

  ngOnInit(): void {}

  previewFile(file: File): void {
    window.open(URL.createObjectURL(this.documentInfo!.file!), '_blank');
  }

  getFileType(file: File): string {
    return file.name.split('.').pop()!.toUpperCase();
  }
}
